import {
  TabList as HuiTabList,
  TabListProps as HuiTabListProps,
} from '@headlessui/react';
import { FC } from 'react';
import { cx } from '@/utils/cx';

export type TabListProps = HuiTabListProps;

export const TabList: FC<TabListProps> = ({
  children,
  className,
  ...props
}) => (
  <HuiTabList
    className={cx(
      'my-3 flex w-full flex-row gap-8 border-b border-b-gray-200',
      className,
    )}
    {...props}
  >
    {children}
  </HuiTabList>
);
